(function() {
  "use strict";

  angular
    .module("app")
    .directive("cccDomainIndicatorPicker", cccDomainIndicatorPicker);

  function cccDomainIndicatorPicker() {
    return {
      restrict: "EA",
      scope: false,
      controller: "DomainIndicatorPickerController"
    };
  }
})();
